export default __webpack_public_path__ + "static/4-207c82cb1e8d92a995d7ab6c745239b6.jpeg";